<template>
  <div class="messageModal">
  	   <div v-if="messageData.title" class="title"> {{ messageData.title }} </div>
  	   <div v-html="messageData.message" v-if="messageData.message" class="message raleway"></div>

       <div v-if="messageData.confirm" class="confirmButtons text-center">
          <div v-if="messageData.confirmTxt" v-on:click="confirm" v-bind:class="{ button: true, primaryButton: messageData.primaryButton == 'confirm' }"> {{ messageData.confirmTxt }} </div> 
          <div v-if="messageData.declineTxt" v-on:click="decline" v-bind:class="{ button: true, primaryButton: messageData.primaryButton == 'decline' }"> {{ messageData.declineTxt }}  </div> 
          <div v-if="messageData.abortTxt" v-on:click="abort" v-bind:class="{ button: true, primaryButton: messageData.primaryButton == 'abort' }"> {{ messageData.abortTxt }}  </div> 
       </div>

  </div> 
</template>

<script>

export default {
  data: function(){ 
    return{
    }
  },

  props: ['messageData'],

  methods: {  

    confirm(){
      if(typeof this.messageData.onConfirm == 'function')
        this.messageData.onConfirm();
    },

    decline(){
      if(typeof this.messageData.onDecline == 'function')
        this.messageData.onDecline();
    },

    abort(){
      if(typeof this.messageData.onAbort == 'function')
        this.messageData.onAbort();
    },
    
  },

  mounted: function () { 

    
  }

}
</script>

<style>

.messageModal{

  .message{
    margin-top: 25px;
    text-align: center;
    font-size: 13px;
    text-transform: uppercase;
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
    line-height: 26px;
  }

  a{
    color: black;
  }

  .confirmButtons{
    margin-top: 20px;
  }

  .primaryButton{
    background: black;
    color: white;
  }

}

</style>



// WEBPACK FOOTER //
// Message.vue?1ae2fb77